import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { ChevronDown, Weight } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

function Blog6D() {
  const [loading, setLoading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
              const [formType, setFormType] = useState(""); // stores which button opened the form
          const [contactForm, setContactForm] = useState({
            fullname: "",
            company: "",
            website: "",
            email: "",
            phone: "",
            message: "",
          });
          const handleContactChange = (e) => {
            const { name, value } = e.target;
            setContactForm((prev) => ({ ...prev, [name]: value }));
          };
          
          
          const isBusinessEmail = (email) => {
            const freeDomains = [
              "gmail.com",
              "yahoo.com",
              "hotmail.com",
              "outlook.com",
              "aol.com",
              "icloud.com",
              "mail.com",
              "live.com"
            ];
            const domain = email.split("@")[1]?.toLowerCase();
            if (!domain) return false;
            return !freeDomains.includes(domain);
          };
          
          
          const handleContactSubmit = async (e) => {
            e.preventDefault();
           
            setLoading(true); // show loading message
            const { fullname, company, website, email, phone, message} = contactForm;
          
          
            // Basic validation
            if (!fullname || !email || !message || !company || !phone ) {
              alert("Please fill all required fields.");
                setLoading(false); // show loading message
          
              return;
            }
          if (!isBusinessEmail(email)) {
              alert("Please enter a business email, not Gmail/Yahoo/etc.");
                setLoading(false); // show loading message
          
              return;
            }
           
          
            try {
                try {
    const emailCheckResponse = await fetch(
      `https://pinakinedgemedia.com/api/validateEmail?email=${email}`
    );
    const emailCheckData = await emailCheckResponse.json();

    if (!emailCheckData.exists) {
      setLoading(false);
      alert("❌ The entered email does not exist. Please use a valid business email.");
      return;
    }
  } catch (err) {
    setLoading(false);
    console.error("Email check failed:", err);
    alert("⚠️ Could not verify email existence. Try again later.");
    return;
  }
              const response = await fetch("https://pinakinedgemedia.com/api/sendContactMail", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
  ...contactForm,
  formType, // ✅ add formType manually here
}),

              });
          
              if (response.ok) {
                 setShowSuccessModal(true);  // ✅ This triggers modal to open
                 setLoading(false); // show loading message
                 setContactForm({
                  fullname: "",
                  company: "",
                  website: "",
                  email: "",
                  phone: "",
                  message: "",
                });
              } else {
                alert("Error sending message.");
              }
            } catch (err) {
              console.error(err);
              alert("Error sending message.");
            }
          };
  return (
    <div>
      <Header />
      <main>
         <AnimatePresence>
                                {showSuccessModal && (
                                  <motion.div
                                    className="modal-overlay show"
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    exit={{ opacity: 0 }}
                                    style={{
                                      position: "fixed",
                                      top: 0,
                                      left: 0,
                                      width: "100%",
                                      height: "100%",
                                      background: "rgba(0,0,0,0.5)",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      zIndex: 9999,
                                    }}
                                  >
                                    <motion.div
                                      className="modal show"
                                      initial={{ scale: 0.8, opacity: 0 }}
                                      animate={{ scale: 1, opacity: 1 }}
                                      exit={{ scale: 0.8, opacity: 0 }}
                                      transition={{ duration: 0.3 }}
                                      style={{
                                        background: "#fff",
                                        padding: "30px",
                                        borderRadius: "10px",
                                        width: "400px",
                                        textAlign: "center",
                                        boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
                                      }}
                                    >
                                      <h2 style={{ fontSize: "20px", marginBottom: "10px" }}>
                                        Message Sent!
                                      </h2>
                                      <p>Thank you for contacting us. We will get back to you shortly.</p>
                                      <button className="vc rg lk gh ml il hi gi _l"
                                        onClick={() => setShowSuccessModal(false)}
                                       
                                      >
                                        Close
                                      </button>
                                    </motion.div>
                                  </motion.div>
                                )}
                              </AnimatePresence>
        {/* 🔹 FAQ Section */}
        <section className="i ji ii db">
        
      <div className="bb ze ki xn 2xl:ud-px-0">
        <div className="tc sf yo zf kq">
          <div className="ro1">
            <div className="animate_top rounded-md shadow-solid-13 bg-white dark:bg-blacksection border border-stroke dark:border-strokedark p-7.5 md:p-10">
              
              
              <div className="container">
               <div className="left">
          <img src="../images/blogim6.png" className="vd" alt="Blog" />
        </div>
          <div className="right">
<h2 className="ek vj 2xl:ud-text-title-lg kk wm nb gb mk">
             Turning Interest into Impact—The MarTech Demand Gen Advantage
              </h2>
                <ul className="tc uf cg 2xl:ud-gap-15 fb">
                <li>
                  <span className="rc kk wm">Published On: </span>Oct 13, 2025
                </li>
                  <li>
                   <span className="rc kk wm">Published by:</span> Pinakinedge Media
                </li>
              </ul>
          </div>
            </div>
            <br/>
                <p className="jutfy">
                  In the fast-evolving world of Martech, data drives everything — from lead scoring and customer engagement to sales enablement and campaign optimization. But as competition intensifies and buyer behavior becomes increasingly complex, marketers face a critical challenge: how to identify which companies are truly ready to buy.
                  <br/>
                  This is where intent data has emerged as a game-changer.
                  <br/>
                  In B2B demand generation, understanding who your audience is has always been important — but understanding what they’re actively looking for is what defines success today. Intent data helps Martech companies pinpoint buying signals, prioritize high-value accounts, and deliver hyper-personalized experiences that convert interest into revenue.
</p>
              <p className="mb bgimh">
           Let’s explore how intent data is reshaping B2B demand generation across the Martech landscape.
              </p>
             
              <p className="mb bgimh">
       What Is Intent Data in Martech?
              </p>
               <p className="jutfy">
            Intent data refers to digital information that indicates a company’s likelihood to make a purchase based on its online behavior. It captures signals such as:
              </p>
              
               <ul className="jutfy">
                <li>•	Which topics a company’s employees are researching</li>
<li>•	What type of content they’re engaging with</li>
<li>•	Which competitors they’re evaluating</li>
<li>•	How often they revisit certain themes or keywords

</li>
               </ul>
            
              <p className="jutfy">
                In the Martech space, these signals can reveal when marketing teams are researching “marketing automation platforms,” “AI-driven personalization,” or “customer data integration tools.”
              </p>

              <p className="mb bgimh">
           There are two main types of intent data:
              </p>
               
               <ul className="jutfy">
                <li>
                 •	First-party intent data: Collected directly from your owned platforms — website activity, email engagement, product demos, webinars, or chat interactions.   </li>
  <li>•	Third-party intent data: Aggregated from external digital properties, content consumption, and search activity across the internet.

                </li>
              </ul>
               <p className="jutfy">
When combined, these two data sources give Martech companies a powerful window into who is in-market right now and what solutions they’re considering.
              </p>
              <p className="mb bgimh">
         Why Intent Data Matters for B2B Demand Generation in Martech
<br/>
<br/>
1. From Broad Targeting to Precise Prospecting

              </p>
               <p className="jutfy">
              Traditional B2B demand generation often relies on firmographics — industry, company size, or job title — to define audiences. But these parameters don’t indicate intent to purchase.
              <br/>
              With intent data, Martech marketers can identify companies that are actively researching topics related to their offerings. Instead of blasting campaigns to a generic list, they can target accounts showing real buying behavior.
              <br/>
              <br/>
              For instance, if data reveals a surge in searches for “customer journey analytics,” that’s a clear signal that specific accounts may be evaluating Martech vendors. Outreach can then focus on these accounts with tailored, high-value content.

<br/>
<br/>
The result: higher-quality leads, improved conversion rates, and lower customer acquisition costs.
              </p>
            
                 <p className="mb bgimh">
      2. Powering Account-Based Marketing (ABM) with Real-Time Insights
              </p>
               <p className="jutfy">
             Intent data and Account-Based Marketing (ABM) are a natural fit — particularly in the Martech ecosystem, where deals often involve multiple stakeholders and complex decision-making.
             <br/>
             Intent data enables marketing teams to:
              </p>
               <ul className="jutfy">
              <li>•	Identify which target accounts are actively engaging with relevant topics</li>
<li>•	Prioritize “in-market” accounts for immediate outreach</li>
<li>•	Personalize content and messaging based on what each account cares about most

</li>
              </ul>
              <p className="jutfy">
                For example, if a marketing operations leader at a target company is researching “data unification platforms,” while their CMO is exploring “marketing ROI analytics,” that account is heating up. Your sales and marketing teams can collaborate to create multi-threaded, intent-driven campaigns that resonate with each persona.
              </p>
            
              <p className="mb bgimh">
     This data-driven ABM approach ensures you’re engaging accounts when interest is highest — not months later.
     <br/>
     <br/>
     3. Enhancing Lead Scoring and Qualification
              </p>
             
              <p className="jutfy">
               Martech companies often capture thousands of leads from downloads, webinars, or free trials — but only a fraction convert into customers. Intent data adds a critical behavioral layer to lead scoring models.
               <br/>
               Instead of ranking leads solely on demographics or engagement volume, intent data helps score them based on buying readiness.
               <br/>
               For example:
             </p>
            <ul className="jutfy">
              <li>
                •	A lead downloading one eBook is less valuable than an account where multiple employees are simultaneously consuming content around “data orchestration” or “cross-channel personalization.”</li>
 <li>•	This aggregated intent signal shows collective buying interest, making the account a high-priority opportunity for sales.

              </li>
            </ul>
            <p className="jutfy">
              The outcome: sales and marketing alignment improves, and teams focus their energy on accounts that are most likely to close.

            </p>
             <p className="mb bgimh">
              4. Enabling Personalization at Scale
             </p>
              <p className="jutfy">
              In the Martech world, personalization isn’t just a buzzword — it’s a growth engine. But true personalization requires context.

<br/>
Intent data provides that context. By identifying what topics and solutions an account is researching, marketers can craft personalized content journeys that match each buyer’s stage and interest area.
             </p>
             <ul className="jutfy">
              <li>
                •	If a prospect shows intent around “AI-driven marketing automation,” you can deliver use cases and customer success stories on that topic.      </li>
  <li>•	If another account is exploring “data integration challenges,” you can target them with product explainers or webinars on API flexibility and system interoperability.

              </li>
             </ul>
             <p className="jutfy">
This level of personalization increases engagement, accelerates decision-making, and positions your brand as a relevant, trusted authority.
             </p>
               <p className="mb bgimh">
5. Shortening the B2B Sales Cycle
               </p>
                 <p className="jutfy">
The average B2B Martech purchase involves several stakeholders — marketers, IT teams, procurement, and leadership. Intent data helps you understand who within an organization is engaging and what they’re researching, allowing for more strategic sales engagement.
<br/>
If intent data shows rising interest across multiple personas in a single company, that’s a signal to advance the conversation with a tailored proposal or demo.
<br/>
In short, intent data helps sales teams focus on the right accounts, at the right time, which significantly shortens the sales cycle and improves win rates.
                 </p>

                  <p className="mb bgimh">
6. Strengthening Marketing and Sales Alignment
               </p>
                 <p className="jutfy">
                  One of the top barriers to effective demand generation in Martech is the disconnect between marketing and sales. Marketing often delivers “leads,” but sales claims they’re not ready. Intent data bridges that gap.
                  <br/>
                  With a shared, real-time view of which accounts are surging in intent, both teams can:
                 </p>
<ul className="jutfy">
  <li>
    •	Coordinate outreach strategies  </li>
<li>•	Align messaging to the buyer’s current research stage  </li>
<li>•	Track engagement metrics that reflect real purchase behavior

  </li>
</ul>
 <p className="jutfy">
                  This synergy ensures every touchpoint — from ad campaigns to sales calls — feels cohesive, relevant, and data-driven.
                 </p>
                  <p className="mb bgimh">
Best Practices for Using Intent Data in Martech Demand Generation
               </p>
               <ul  className="jutfy">
             
  <li>•	Integrate Data Across Systems: Combine CRM, marketing automation, and intent data sources into a unified dashboard.  </li>
  <li>•	Leverage AI for Predictive Insights: Use machine learning to detect emerging buying patterns and prioritize accounts dynamically.  </li>
  <li>•	Prioritize Privacy and Compliance: Ensure adherence to GDPR, CCPA, and ethical data usage standards to build trust.  </li>
  <li>•	Align Teams on Shared KPIs: Measure success through intent-qualified leads, account engagement scores, and revenue impact.  </li>
  <li>•	Continuously Optimize: Regularly analyze which intent signals correlate most strongly with closed deals, and refine targeting accordingly.

                </li>
               </ul>

                  <p className="mb bgimh">
The Future of Martech Demand Generation Is Intent-Driven
               </p>
                 <p className="jutfy">
                  In a marketplace overflowing with content, ads, and automation, the brands that win are those that understand intent — not just identity.
                  <br/>
                  Intent data is transforming how Martech companies identify prospects, personalize outreach, and accelerate pipeline growth. It’s not just a new data source — it’s a strategic advantage that turns uncertainty into precision
                  <br/>
                  As B2B buying becomes increasingly digital and self-directed, intent-driven demand generation will define the next generation of Martech leaders. Those who harness it early will build smarter funnels, stronger relationships, and sustainable growth in an ever-evolving landscape.
                 </p>

                   <p className="mb bgimh">
Ready to turn intent into intelligent demand? Let’s talk about how we can power your Martech growth.
               </p>
              <div className="animate_top w-full nn/5 vo/3 vk sg hh sm yh tq">
                <form onSubmit={(e) => handleContactSubmit(e)}>
  <div className="tc sf yo ap zf xi1">
    <div className="vd to/2">
      <label className="rc" htmlFor="fullname">Full name</label>
      <input
        type="text"
        name="fullname"
        id="fullname"
        value={contactForm.fullname}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>

    <div className="vd to/2">
      <label className="rc" htmlFor="company">Company</label>
      <input
        type="text"
        name="company"
        id="company"
        value={contactForm.company}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>
  </div>

  <div className="tc sf yo ap zf xi1">
    <div className="vd to/2">
      <label className="rc" htmlFor="website">Phone number</label>
        <input
  type="text"
  name="phone"
  id="phone"
  value={contactForm.phone}
  onChange={(e) => {
    // Allow only digits
    const value = e.target.value.replace(/\D/g, "");
    setContactForm((prev) => ({ ...prev, phone: value }));
  }}
  maxLength={10} // optional: limit to 10 digits
  className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
/>

    </div>

    <div className="vd to/2">
      <label className="rc" htmlFor="email">Email address</label>
      <input
        type="email"
        name="email"
        id="email"
        value={contactForm.email}
        onChange={handleContactChange}
        className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
      />
    </div>
  </div>
  <div className="fb">
    <label className="rc" htmlFor="message">Comment</label>
    <textarea
      placeholder="Comment"
      rows="3"
      name="message"
      id="message"
      value={contactForm.message}
      onChange={handleContactChange}
      className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 ci"
    ></textarea>
  </div>

  <div className="tc xf">
      <button
  type="submit"
  className="vc rg lk gh ml il hi gi _l"
  disabled={loading}
  onClick={() => {
    setFormType("Blog: Turning Interest into Impact—The MarTech Demand Gen Advantage");
  }}
>
  {loading ? "Please wait..." : " Post Comment"}
</button>
  </div>
</form>
            </div>
            </div>
          </div>
        </div>
      </div>
    </section>
       
      </main>
      <Footer />
    </div>
  );
}

export default Blog6D;
